import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { CarouselModule } from 'primeng/carousel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ImageModule } from 'primeng/image';
import { TextareaModule } from 'primeng/textarea';
import {FilepickerFormcontrol} from "./filepicker-formcontrol.component";
import {CoreLibModule} from 'core-lib';



@NgModule({
    declarations: [FilepickerFormcontrol],
    imports: [
        CommonModule,
        FileUploadModule,
        ButtonModule,
        MessageModule,
        InputTextModule,
        CarouselModule,
        ImageModule,
        CoreLibModule,
        ProgressBarModule,
        TextareaModule,
    ],
    exports: [FilepickerFormcontrol]
})
export class FilepickerFormcontrolModule { }
